/*=========================================================================================
  File Name: moduleKainsActions.js
  Description: Kains Module Actions
  ----------------------------------------------------------------------------------------
==============================*/
import kindsService from '../../../services/kinds.service'

export default {
	addKinds({ dispatch }, params) {
		return kindsService
			.createKinds(params)
			.then((response) => {
				dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
			})
			.catch((error) => {
				if (Object.values(error.errors).length > 0) {
					dispatch('alertError', Object.values(error.errors)[0][0], { root: true })
				} else dispatch('alertError', typeof error.message == 'object' ? error.message[0] : error.message, { root: true })
			})
	},
	updateKinds({ commit, dispatch }, data) {
		return kindsService
			.updateKinds(data)
			.then((response) => {
				// commit('UPDATE_USER', data)
				dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
			})
			.catch((error) => {
				if (typeof error.errors == 'object') {
					if (Object.values(error.errors).length > 0) {
						dispatch('alertError', Object.values(error.errors)[0][0], { root: true })
					}
				} else dispatch('alertError', typeof error.message == 'object' ? error.message[0] : error.message, { root: true })
			})
	},
	fetchKinds({ commit, dispatch }, payload) {
		return kindsService
			.getKinds(payload)
			.then((response) => {
				commit('SET_KINDS', response.data.data)
				commit('SET_INFO_DB', { totalPage: response.data.last_page, totalRow: response.data.total })
				return Promise.resolve(response.data.data)
			})
			.catch((error) => {
				if (Object.values(error.errors).length > 0) {
					dispatch('alertError', Object.values(error.errors)[0][0], { root: true })
				} else dispatch('alertError', typeof error.message == 'object' ? error.message[0] : error.message, { root: true })
			})
	},
	showKinds({ dispatch }, id) {
		return kindsService
			.showKinds(id)
			.then((response) => {
				return Promise.resolve(response.data)
			})
			.catch((error) => {
				if (typeof error.errors == 'object') {
					if (Object.values(error.errors).length > 0) {
						dispatch('alertError', Object.values(error.errors)[0][0], { root: true })
					}
				} else dispatch('alertError', typeof error.message == 'object' ? error.message[0] : error.message, { root: true })
			})
	},
	removeKinds({ commit, dispatch }, ids) {
		return kindsService
			.deleteKinds({ cids: ids })
			.then((response) => {
				dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
			})
			.catch((error) => {
				if (typeof error.errors == 'object') {
					if (Object.values(error.errors).length > 0) {
						dispatch('alertError', Object.values(error.errors)[0][0], { root: true })
					}
				} else dispatch('alertError', typeof error.message == 'object' ? error.message[0] : error.message, { root: true })
			})
	},
	async getListKinds({ dispatch, commit }, type) {
		return await kindsService
			.getListKinds(type)
			.then((response) => {
				if (response.success && response.data) {
					// dispatch("alertSuccess", response.message, { root: true });
					return Promise.resolve(response.data)
				} else {
					dispatch('alertError', response.message, { root: true })
				}
			})
			.catch((error) => {
				dispatch('alertError', error, { root: true })
				return Promise.reject(false)
			})
	}
}
